import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Produto } from 'src/app/_models';
import { StatusLogProtocolo } from 'src/app/_models/StatusLogProtocolo';

export interface StatusProtocolo {
  idProtocolo: number;
  registros: StatusLogProtocolo[];
}

@Component({
  selector: 'app-status-protocolo-fiscal-modal',
  templateUrl: './status-protocolo-fiscal-modal.html',
  styleUrls: ['./status-protocolo-fiscal-modal.css']
})

export class StatusProtocoloFiscalModalComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public dataSource: MatTableDataSource<StatusLogProtocolo>;
  semDados = {} as boolean;
  displayedColumns = ['usuario', 'dataStatus', 'acao', 'descricao'];

  constructor(
    private matDialogRef: MatDialogRef<StatusProtocoloFiscalModalComponent, Produto[]>,
    @Inject(MAT_DIALOG_DATA) public status: StatusProtocolo) {

  }

  ngOnInit() {
    this.semDados = true;
    this.dataSource = new MatTableDataSource<StatusLogProtocolo>(this.status.registros);
    this.semDados = false;
    this.dataSource.paginator = this.paginator;
  }


  cancelar(): void {
    this.matDialogRef.close();
  }

  applyFilter(event) {
    this.dataSource.filter = event;
  }


}
